import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { createWithEqualityFn } from 'zustand/traditional';

import { type FlowFolderProps } from './FlowFoldersStore';

type FlowFoldersDraft = Record<string, Pick<FlowFolderProps, 'id' | 'name' | 'parent'>>;

// TODO
// Pausable stores?

class FlowFoldersDraftStore {
  store: ReturnType<FlowFoldersDraftStore['createStore']>;
  pendingClears: {
    flowFolders: boolean;
  };

  constructor() {
    this.store = this.createStore();
    this.pendingClears = {
      flowFolders: false,
    };
  }

  createStore() {
    return createWithEqualityFn<{
      flowFolders?: FlowFoldersDraft;
      flowFoldersState?: 'pending' | 'done';
    }>()(
      devtools(
        subscribeWithSelector((set, get, api) => {
          return {};
        }),
        {
          name: 'flow-folders-draft',
        },
      ),
      Object.is,
    );
  }

  get get() {
    return this.store.getState;
  }

  get set() {
    return this.store.setState;
  }

  setFlowFoldersDraft({ flowFolders }: { flowFolders: FlowFoldersDraft }) {
    if (this.get().flowFoldersState === 'pending') {
      return;
    }

    this.set({
      flowFolders,
      flowFoldersState: 'pending',
    });
  }

  setFlowFoldersDraftDone() {
    this.set({
      flowFoldersState: 'done',
    });

    if (this.pendingClears.flowFolders === true) {
      this.set({
        flowFolders: undefined,
        flowFoldersState: undefined,
      });
      this.pendingClears.flowFolders = false;
    }

    // TODO
    // We should set something like a max timer here that when the notify never comes the state is still cleared.
    // We can expect the update to be received within 15 seconds.
  }

  setFlowFoldersDraftFailed() {
    this.set({
      flowFolders: undefined,
      flowFoldersState: undefined,
    });
  }

  notify() {
    if (this.get().flowFolders != null && this.get().flowFoldersState === 'done') {
      this.set({
        flowFolders: undefined,
        flowFoldersState: undefined,
      });
    }

    if (this.get().flowFolders != null && this.get().flowFoldersState === 'pending') {
      this.pendingClears.flowFolders = true;
    }
  }
}

export const flowFoldersDraftStore = new FlowFoldersDraftStore();
